import React from 'react';
import PropTypes from 'prop-types';

import {
  Segment,
  Text,
  Title,
} from './styles';

const ThankYouPage = (props) => {
  const { location } = props;

  const {
    state: {
      title = '',
      content = '',
    } = {},
  } = location;

  return (
    <Segment>
      <Title>
        {title}
      </Title>
      <Text margin>
        {content}
      </Text>
    </Segment>
  );
};

ThankYouPage.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.string,
    }),
  }).isRequired,
};

export default ThankYouPage;
